import { ServiceHost } from "@/core";
import { authenticationService } from "./authentication/authentication-service";
import { databaseService } from "./database/database-service";
import { functionsService } from "./functions/functions-service";

/**
 * Service Host
 *
 * @export
 * @interface ServiceHost
 */
export const serviceHost: ServiceHost = {
  /**
   * Get database service
   *
   * @return {DatabaseService}
   */
  getDatabaseService() {
    return databaseService;
  },
  getFunctionsService() {
    return functionsService;
  },
  getAuthenticationService() {
    return authenticationService;
  },
};
